import React from 'react';
import { Datagrid, TextField, ReferenceField, usePermissions } from 'react-admin';

import { List } from '~/layout';
import { BooleanField, NoPermissions, ShowController } from '~/components/ra';
import IdentityEdit from './IdentityCreate';
import { StatusField } from '~/components';
import { Filter } from 'react-admin';
import { TextInput } from 'react-admin';
import { useTranslate } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import { SelectInput } from 'react-admin';

export const label = (key: string) => `resources.team.fields.${key}`;
const d = (key: string) => `utils.${key}`;

const IdentityList = (props: any) => {
  const { permissions } = usePermissions();
  if (!permissions) return null;
  if (!permissions.includes('identity.list')) return <NoPermissions />;

  return (
    <List
      {...props}
      bulkActionButtons={false}
      actions={<IdentityEdit permissions={permissions} />}
      filters={<Filters />}
    >
      <Datagrid rowClick='show' size='medium' selectedIds={null}>
        <TextField source='username' label='resources.team.fields.username' sortable={false} />
        <TextField source='firstName' label='resources.team.fields.firstName' sortable={false} />
        <TextField source='lastName' label='resources.team.fields.lastName' sortable={false} />
        <TextField source='email' label='resources.team.fields.email' sortable={false} />
        <ReferenceField
          source='roleId'
          reference='roles'
          link={false}
          label='resources.team.fields.roleId'
          sortable={false}
        >
          <TextField source='name' />
        </ReferenceField>
        <ShowController label='resources.team.fields.status'>
          {({ showRecord }) => {
            return showRecord.deleted ? (
              <StatusField status='DISABLED' />
            ) : (
              <StatusField status='ENABLED' />
            );
          }}
        </ShowController>
        <ShowController label={'resources.team.fields.2FA'}>
          {({ showRecord }) => {
            const is2FaEnabled =
              showRecord?.totp ||
              !!(showRecord?.requiredActions || []).find((item: any) => item === 'CONFIGURE_TOTP');
            return <BooleanField value={is2FaEnabled} nullOnFalse />;
          }}
        </ShowController>
      </Datagrid>
    </List>
  );
};

const Filters = (props: any) => {
  const translate = useTranslate();
  const t = (key: any) => translate(label(key));
  const classes = useStyles();
  return (
    <Filter {...props} className={classes.form}>
      <TextInput
        name='username'
        source='username'
        label={t('username')}
        alwaysOn
        className={classes.formControl}
      />
      <TextInput
        name='firstName'
        source='firstName'
        label={t('firstName')}
        alwaysOn
        className={classes.formControl}
      />
      <TextInput
        name='lastName'
        source='lastName'
        label={t('lastName')}
        alwaysOn
        className={classes.formControl}
      />
      <TextInput
        name='email'
        source='email'
        label={t('email')}
        alwaysOn
        className={classes.formControl}
      />
      <SelectInput
        label={label('enabled')}
        source='enabled'
        choices={[
          { id: true, name: d('yes') },
          { id: false, name: d('no') },
        ]}
        alwaysOn
        className={classes.formControl}
        emptyText={d('any')}
      />
    </Filter>
  );
};

const useStyles = makeStyles((theme) => ({
  bottomSpacing: {
    marginBottom: theme.spacing(2),
  },
  filters: {
    alignItems: 'flex-start',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  form: {
    '& > div': {
      '& > div:last-child': {
        width: theme.spacing(1),
      },
    },
  },
  formControl: {
    width: 200,
  },
}));

export default IdentityList;
